export const SearchBy = {
  REGISTRY_NUMBER: 'registryNumber',
  VIN_NUMBER: 'vinNumber',
  POLICY_NUMBER: 'policyNumber'
};
